import { render, staticRenderFns } from "./System-client.vue?vue&type=template&id=5e2ca26b&scoped=true&"
import script from "./System-client.vue?vue&type=script&lang=js&"
export * from "./System-client.vue?vue&type=script&lang=js&"
import style0 from "./System-client.vue?vue&type=style&index=0&id=5e2ca26b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ca26b",
  null
  
)

export default component.exports